import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import { useSelector } from 'react-redux'
import { useIntersection } from 'react-use'

import { NAV_BRAND } from '@/config'
import { PORTAL_TYPE_YF } from '@/config/constants'
import Nothing from '@/generic/components/Nothing'
import { JOB_LP } from '@/page/constants'
import { getPageType } from '@/page/store/selectors'

import {
  hasSearchTypes
} from '../constants'
import { getShowMobileSearchForm } from '../store/selectors'

import SearchForm from './SearchForm'

export const SearchBar = ({ onSubmitAction }) => {
  const ref = useRef()
  const { portal_type: portalType } = NAV_BRAND
  const { current: isYF } = useRef(portalType === PORTAL_TYPE_YF)

  const hideSearchFormOnMobile = useSelector((state) =>
    getPageType(state) === JOB_LP &&
    !getShowMobileSearchForm(state)
  )

  const intersection = useIntersection(ref, {
    threshold: 0.001 // to check visibility, threshold should have small value greater than 0
  })

  return (
    <div
      ref={ref}
      className={classnames('nav-bar nav-bar-search', { desktop: hideSearchFormOnMobile })}
    >
      <nav className='navbar navbar-dark'>
        <div className={classnames('search-bar d-block', { 'mx-auto': !isYF })}>
          {intersection?.isIntersecting && <SearchForm onSubmitAction={onSubmitAction} />}
        </div>
      </nav>
    </div>
  )
}

SearchBar.propTypes = {
  onSubmitAction: PropTypes.func
}

export default !hasSearchTypes ? Nothing : SearchBar
